import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface TitleProps {
    firstLine: ReactNode | (() => ReactNode);
    secondLine: ReactNode | (() => ReactNode);
    className?: string;
    animate?: boolean;
}

function Title({
    firstLine,
    secondLine,
    className = '',
    animate = true
}: TitleProps) {
    const content = (
        <h2 className={`text-[32px] md:text-[46px] max-w-[500px] ${className}`}>
            <span className="block mb-2 font-sans font-extralight uppercase leading-[1.02]">
                {typeof firstLine === 'function' ? firstLine() : firstLine}
            </span>
            <span className="block italic font-normal font-serif uppercase leading-[1.08]">
                {typeof secondLine === 'function' ? secondLine() : secondLine}
            </span>
        </h2>
    );

    if (!animate) return content;

    return (
        <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
        >
            {content}
        </motion.div>
    );
}

export default Title; 